import cx from "classnames";
import React from "react";
import useDisplayOptions from "../../hooks/useDisplayOptions";
import useJourneyLeg from "../../hooks/useJourneyLeg";
import SplitTicketType from "../../types/SplitTicketType";
import SeatReservations from "../SeatReservations";
import AmenitiesInformationList from "./components/AmenitiesInformationList";
import BikeReservation from "./components/BikeReservation";
import CollapsibleCallingPoints from "./components/CollapsibleCallingPoints";
import LegHeader from "./components/LegHeader";
import OnboardServicesFooter from "./components/OnboardServicesFooter";
import PaidTicketOptionsFooter from "./components/PaidTicketOptionsFooter";
import SplitSaveAlert from "./components/SplitSaveAlert";
import SubHeaderRow from "./components/SubHeaderRow";
import TerminalCallingPoint from "./components/TerminalCallingPoint";
import * as s from "./TransitLeg.module.css";
const TransitLeg = ({ legId }) => {
  const {
    amenities,
    legNumber,
    pnrReference,
    seatReservations,
    splitSave,
    extras,
    onboardServices,
    bikeReservations
  } = useJourneyLeg(legId);
  const { cardStyleLegs, displaySeatReservations } = useDisplayOptions();
  const hasSplitSave = !!splitSave && (splitSave.type === SplitTicketType.DIRECT_SPLIT || splitSave.type === SplitTicketType.INTERCHANGE_SPLIT);
  const hasHeader = legNumber || pnrReference || hasSplitSave;
  const hasSeatReservations = seatReservations && seatReservations.length > 0;
  const hasFooter = !!((extras == null ? void 0 : extras.length) || (bikeReservations == null ? void 0 : bikeReservations.length) || (onboardServices == null ? void 0 : onboardServices.length) || hasSeatReservations);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, hasHeader && /* @__PURE__ */ React.createElement(LegHeader, {
    legId
  }), /* @__PURE__ */ React.createElement("div", {
    className: cx(s.transitLeg, {
      [s.cardBody]: cardStyleLegs,
      [s.hasHeader]: hasHeader,
      [s.hasFooter]: hasFooter || hasSeatReservations
    })
  }, splitSave && splitSave.type === SplitTicketType.DIRECT_SPLIT && /* @__PURE__ */ React.createElement(SplitSaveAlert, {
    requiresSeatChange: splitSave.requiresSeatChange,
    stationToChange: splitSave.stationToChange
  }), /* @__PURE__ */ React.createElement(SubHeaderRow, {
    legId
  }), /* @__PURE__ */ React.createElement("ul", {
    className: s.track
  }, /* @__PURE__ */ React.createElement(TerminalCallingPoint, {
    type: "origin",
    legId
  }), amenities && /* @__PURE__ */ React.createElement(AmenitiesInformationList, {
    amenities: amenities.map((amenity) => amenity.name)
  }), /* @__PURE__ */ React.createElement(CollapsibleCallingPoints, {
    type: "intermediate",
    legId
  }), /* @__PURE__ */ React.createElement(TerminalCallingPoint, {
    type: "destination",
    legId
  }))), hasFooter && /* @__PURE__ */ React.createElement("div", {
    className: s.footerContainer
  }, displaySeatReservations && /* @__PURE__ */ React.createElement(SeatReservations, {
    legId
  }), extras && /* @__PURE__ */ React.createElement(PaidTicketOptionsFooter, {
    extras
  }), onboardServices && /* @__PURE__ */ React.createElement(OnboardServicesFooter, {
    onboardServices
  }), bikeReservations && /* @__PURE__ */ React.createElement(BikeReservation, {
    bikeReservations
  })));
};
var TransitLeg_default = TransitLeg;
export {
  TransitLeg_default as default
};
